// A2 - Ünite 3: Future - Will & Going to
// Hedef: Gelecek zaman, planlar, tahminler

export const A2_UNIT_3 = {
  'A2-U3-L1': {
    id: 'A2-U3-L1',
    title: 'Will + fiil (Gelecek Zaman)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will - Gelecek Zaman',
          explanation: '"Will" gelecekte olacak eylemler, anlık kararlar ve tahminler için kullanılır. Tüm öznelerle aynı şekilde kullanılır.',
          table: {
            headers: ['Özne', 'Will', 'Fiil', 'Örnek'],
            rows: [
              ['I', 'will', 'help', 'I will help you.'],
              ['You', 'will', 'see', 'You will see the captain.'],
              ['He/She', 'will', 'arrive', 'She will arrive soon.'],
              ['We', 'will', 'serve', 'We will serve dinner.'],
              ['They', 'will', 'land', 'They will land at 5 PM.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Cümle', 'Türkçesi', 'Kullanım'],
            rows: [
              ['The flight will depart at 10 AM.', 'Uçuş saat 10:00\'da kalkacak.', 'Program'],
              ['I will check on that for you.', 'Sizin için kontrol edeceğim.', 'Anlık karar'],
              ['We will experience some turbulence.', 'Biraz türbülans yaşayacağız.', 'Tahmin'],
              ['The captain will make an announcement.', 'Kaptan anons yapacak.', 'Bilgi']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Kısaltma: I will = I\'ll, She will = She\'ll, We will = We\'ll'
        },
        {
          type: 'vocabulary',
          title: '✈️ Gelecek Zaman Kelimeleri',
          words: [
            { en: 'tomorrow', tr: 'yarın', pronunciation: '/təˈmɒrəʊ/' },
            { en: 'next week', tr: 'gelecek hafta', pronunciation: '/nekst wiːk/' },
            { en: 'soon', tr: 'yakında', pronunciation: '/suːn/' },
            { en: 'later', tr: 'sonra', pronunciation: '/ˈleɪtə/' },
            { en: 'in the future', tr: 'gelecekte', pronunciation: '' }
          ]
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'The flight _____ at 3 PM.',
          options: ['will arrive', 'arrives will', 'will arrives', 'arriving'],
          correct: 'will arrive',
          explanation: 'will + fiil kök hali'
        },
        {
          type: 'fillInBlank',
          sentence: 'I _____ (help) you with your luggage.',
          answer: 'will help',
          hint: 'Anlık karar - will + fiil'
        },
        {
          type: 'matching',
          instruction: 'Cümleleri tamamlayın',
          pairs: [
            { left: 'We will serve', right: 'dinner soon' },
            { left: 'The plane will land', right: 'at 5 PM' },
            { left: 'I will check', right: 'for you' }
          ]
        }
      ]
    }
  },
  'A2-U3-L2': {
    id: 'A2-U3-L2',
    title: "Won't (Olumsuz)",
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Will Olumsuz',
          explanation: 'Will\'in olumsuz hali: will not (won\'t)',
          table: {
            headers: ['Olumlu', 'Olumsuz', 'Türkçesi'],
            rows: [
              ['I will help', "I won't help", 'Yardım etmeyeceğim'],
              ['She will come', "She won't come", 'Gelmeyecek'],
              ['It will rain', "It won't rain", 'Yağmur yağmayacak'],
              ['We will delay', "We won't delay", 'Geciktirmeyeceğiz']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Havacılık Örnekleri',
          table: {
            headers: ['Olumsuz', 'Türkçesi'],
            rows: [
              ["The flight won't be delayed.", 'Uçuş gecikmeyecek.'],
              ["We won't serve alcohol on this flight.", 'Bu uçuşta alkol servis etmeyeceğiz.'],
              ["There won't be any turbulence.", 'Türbülans olmayacak.'],
              ["I won't forget your request.", 'İsteğinizi unutmayacağım.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 won\'t = will not - Her zaman fiil kök haliyle kullanılır!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: "The flight _____ be delayed.",
          options: ["won't", "willn't", "will not be", "won't be"],
          correct: "won't",
          explanation: "won't + fiil (be)"
        },
        {
          type: 'fillInBlank',
          sentence: "We _____ (not/serve) dinner on this short flight.",
          answer: "won't serve",
          hint: "will not = won't"
        },
        {
          type: 'matching',
          instruction: 'Olumlu ve olumsuz formları eşleştirin',
          pairs: [
            { left: 'I will go', right: "I won't go" },
            { left: 'She will help', right: "She won't help" },
            { left: 'They will arrive', right: "They won't arrive" }
          ]
        }
      ]
    }
  },
  'A2-U3-L3': {
    id: 'A2-U3-L3',
    title: 'Going to + fiil (Planlar)',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Going to - Planlar ve Niyetler',
          explanation: '"Going to" önceden planlanmış eylemler ve kesin tahminler için kullanılır.',
          table: {
            headers: ['Özne', 'Be', 'Going to', 'Örnek'],
            rows: [
              ['I', 'am', 'going to fly', 'I am going to fly tomorrow.'],
              ['You', 'are', 'going to work', 'You are going to work hard.'],
              ['He/She', 'is', 'going to check', 'She is going to check the cabin.'],
              ['We', 'are', 'going to serve', 'We are going to serve lunch.'],
              ['They', 'are', 'going to land', 'They are going to land soon.']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Will vs Going to',
          table: {
            headers: ['Will', 'Going to', 'Fark'],
            rows: [
              ["I'll help you.", "I'm going to help you.", 'Anlık karar vs önceden plan'],
              ['It will rain.', 'It\'s going to rain.', 'Genel tahmin vs kanıta dayalı'],
              ["I'll be a pilot.", "I'm going to be a pilot.", 'Hayal vs kesin niyet']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 Mülakatta "I\'m going to..." planlarınızı anlatmak için idealdir!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'I _____ apply for the cabin crew position.',
          options: ['am going to', 'is going to', 'are going to', 'going to'],
          correct: 'am going to',
          explanation: 'I am going to + fiil'
        },
        {
          type: 'fillInBlank',
          sentence: 'She _____ (be going to / start) training next month.',
          answer: 'is going to start',
          hint: 'She is going to + fiil'
        },
        {
          type: 'multipleChoice',
          question: 'We _____ serve dinner in 30 minutes. (plan)',
          options: ['are going to', 'will', 'going to', 'is going to'],
          correct: 'are going to',
          explanation: 'Önceden planlanmış = going to'
        }
      ]
    }
  },
  'A2-U3-L4': {
    id: 'A2-U3-L4',
    title: 'Will you...? / Are you going to...?',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '📚 Gelecek Zaman Sorular',
          table: {
            headers: ['Yapı', 'Örnek', 'Türkçesi'],
            rows: [
              ['Will + özne + fiil?', 'Will you help me?', 'Bana yardım eder misin?'],
              ['Be + özne + going to + fiil?', 'Are you going to fly tomorrow?', 'Yarın uçacak mısın?']
            ]
          }
        },
        {
          type: 'grammar',
          title: '✈️ Mülakat Soruları',
          table: {
            headers: ['Soru', 'Türkçesi', 'Cevap Örneği'],
            rows: [
              ['Will you relocate?', 'Taşınır mısınız?', 'Yes, I will.'],
              ['Are you going to complete the training?', 'Eğitimi tamamlayacak mısınız?', 'Yes, I am.'],
              ['Will you work irregular hours?', 'Düzensiz saatlerde çalışır mısınız?', 'Yes, I will.'],
              ['What are you going to do after training?', 'Eğitimden sonra ne yapacaksınız?', "I'm going to..."]
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Will you...?" tekliflerde de kullanılır: "Will you marry me?" gibi.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '_____ you relocate for this job?',
          options: ['Will', 'Do', 'Are', 'Have'],
          correct: 'Will',
          explanation: 'Will + özne + fiil?'
        },
        {
          type: 'fillInBlank',
          sentence: '_____ you going to apply for this position?',
          answer: 'Are',
          hint: 'Be + özne + going to?'
        },
        {
          type: 'matching',
          instruction: 'Soruları cevaplarla eşleştirin',
          pairs: [
            { left: 'Will you work weekends?', right: 'Yes, I will.' },
            { left: 'Are you going to move?', right: 'Yes, I am.' },
            { left: 'Will the flight be delayed?', right: "No, it won't." }
          ]
        }
      ]
    }
  },
  'A2-U3-L5': {
    id: 'A2-U3-L5',
    title: 'Uygulama: Kariyer Planları',
    type: 'lesson',
    content: {
      sections: [
        {
          type: 'grammar',
          title: '✈️ Kariyer Planı Anlatımı',
          explanation: 'Mülakatta gelecek planlarınızı anlatırken:',
          table: {
            headers: ['Plan', 'Cümle'],
            rows: [
              ['Kısa vadeli', "I'm going to complete the training successfully."],
              ['Orta vadeli', "I'm going to become an experienced cabin crew member."],
              ['Uzun vadeli', 'I will aim to become a purser in 5 years.'],
              ['Niyet', "I'm going to learn new languages."],
              ['Vaat', 'I will always provide excellent service.']
            ]
          }
        },
        {
          type: 'tip',
          content: '💡 "Where do you see yourself in 5 years?" sorusuna will/going to ile cevap verin!'
        },
        {
          type: 'vocabulary',
          title: '✈️ Kariyer Kelimeleri',
          words: [
            { en: 'promote', tr: 'terfi ettirmek', pronunciation: '/prəˈməʊt/' },
            { en: 'advance', tr: 'ilerlemek', pronunciation: '/ədˈvɑːns/' },
            { en: 'achieve', tr: 'başarmak', pronunciation: '/əˈtʃiːv/' },
            { en: 'develop', tr: 'geliştirmek', pronunciation: '/dɪˈveləp/' },
            { en: 'goal', tr: 'hedef', pronunciation: '/ɡəʊl/' }
          ]
        }
      ],
      exercises: [
        {
          type: 'fillInBlank',
          sentence: 'In 5 years, I _____ (be) a senior cabin crew member.',
          answer: 'will be',
          hint: 'Uzun vadeli hedef - will'
        },
        {
          type: 'fillInBlank',
          sentence: "I _____ (be going to / apply) for this position because I love aviation.",
          answer: 'am going to apply',
          hint: 'Kesin niyet - going to'
        },
        {
          type: 'speaking',
          instruction: 'Kariyer planlarınızı anlatın:',
          phrases: [
            "I'm going to...",
            'I will...',
            'In 5 years, I will...',
            'My goal is to...'
          ]
        }
      ]
    }
  },
  'A2-U3-EXAM': {
    id: 'A2-U3-EXAM',
    title: 'Ünite 3 Sınavı',
    type: 'exam',
    exercises: [
      {
        type: 'multipleChoice',
        question: 'The flight _____ at 3 PM tomorrow.',
        options: ['will depart', 'depart', 'departing', 'departed'],
        correct: 'will depart',
        explanation: 'Gelecek zaman: will + fiil'
      },
      {
        type: 'multipleChoice',
        question: "We _____ serve alcohol on this flight.",
        options: ["won't", "willn't", "don't will", "not will"],
        correct: "won't",
        explanation: "Olumsuz: won't + fiil"
      },
      {
        type: 'multipleChoice',
        question: 'I _____ apply for the position next week.',
        options: ['am going to', 'is going to', 'going to', 'will going to'],
        correct: 'am going to',
        explanation: 'Plan: I am going to + fiil'
      },
      {
        type: 'multipleChoice',
        question: '_____ you relocate for this job?',
        options: ['Will', 'Do', 'Are', 'Did'],
        correct: 'Will',
        explanation: 'Gelecek zaman sorusu: Will + özne + fiil?'
      },
      {
        type: 'fillInBlank',
        sentence: 'She _____ (be going to / start) training next month.',
        answer: 'is going to start',
        hint: 'She is going to + fiil'
      },
      {
        type: 'matchPairs',
        instruction: 'Uygun zamanı seçin',
        pairs: [
          { left: 'Anlık karar', right: 'will' },
          { left: 'Önceden plan', right: 'going to' },
          { left: 'Genel tahmin', right: 'will' },
          { left: 'Kesin niyet', right: 'going to' }
        ]
      }
    ]
  }
};

export default A2_UNIT_3;
